import { Link } from "react-router-dom";

export default function Logo({ small = false }) {
  return (
    <Link to="/" data-testid="site-logo" className="inline-block leading-none group">
      <div style={{ fontFamily: "'Sifonn', 'Ubuntu', sans-serif" }} className={`font-bold tracking-[0.08em] ${small ? "text-2xl" : "text-3xl sm:text-[32px]"}`}>
        <span className="gold-text">qwerjoh</span><span className="text-white">.</span>
      </div>
      <div className={`text-white uppercase tracking-[0.3em] ${small ? "text-[8px]" : "text-[9px] sm:text-[10px]"} mt-1 text-right pr-[0.05em]`}>
        MEDIA
      </div>
    </Link>
  );
}
